import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Hub } from 'aws-amplify/utils';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  returnUrl = '/';

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);

  constructor() { }

  async ngOnInit() {
    const groups = await this.authService.getUserGroups();
    console.log('getUserGroups():', groups);
    Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signedIn':
          this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
          this.router.navigate([this.returnUrl]);
          this.authService.refreshAuthState();
          break;
        case 'signedOut':
          this.router.navigate(['/login']);
          this.authService.refreshAuthState();
          break;
      }
    });
  }
}

